import { render, staticRenderFns } from "./categorymanagement.vue?vue&type=template&id=6aff7d26&scoped=true"
import script from "./categorymanagement.vue?vue&type=script&lang=js"
export * from "./categorymanagement.vue?vue&type=script&lang=js"
import style0 from "./categorymanagement.vue?vue&type=style&index=0&id=6aff7d26&prod&lang=less"
import style1 from "./categorymanagement.vue?vue&type=style&index=1&id=6aff7d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff7d26",
  null
  
)

export default component.exports